import { FC } from 'react';
import ContainerTypeDashboard from 'src/pages/Settings/ContainerTypesDashboard';
import UserDashboard from 'src/pages/Settings/UserDashboard';
import ProductsDashboard from 'pages/Product/ProductsDashboard';
import { MainLayout } from 'pages/MainLayout';
import { useLocation } from 'react-router-dom';
import AddOnDashboard from 'src/pages/Settings/AddOnDashboard';

const SettingDashboard: FC = () => {
  const location = useLocation();

  // Determine which component to render based on the current route
  const renderContent = () => {
    if (location.pathname.includes('/settings/add-ons')) {
      return <AddOnDashboard />;
    }
    if (location.pathname.includes('/settings/products')) {
      return <ProductsDashboard />;
    }
    if (location.pathname.includes('/settings/container-types')) {
      return <ContainerTypeDashboard />;
    }
    if (location.pathname.includes('/settings/users')) {
      return <UserDashboard />;
    }

    // Default to Users tab if no specific route matches
    return <UserDashboard />;
  };

  return (
    <MainLayout>
      <div className="w-full">{renderContent()}</div>
    </MainLayout>
  );
};

export default SettingDashboard;
